import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import {StorageService} from '../services/storage.service';
import {constants} from '../constants/constants';
import { UserService } from '../services/user.service';
/**
 * Interceptor that adds an Authorization header to requests that are authenticated and target the API URL.
 *
 * @param request The request object.
 * @param next The next interceptor in the chain.
 *
 * @returns The next Observable.
 */
export const tokenInterceptor: HttpInterceptorFn = (request, next) => {

    const storage = inject(StorageService);
    const userService = inject(UserService);
    const token = storage.getToken();
    const isRequestAuthorized = token ? true : false;
    const currentUrl = request.url.split('api/')[1];
    
    if (isRequestAuthorized && !constants.publicRoutes.urls.includes(currentUrl)) {
        let tenantId = '';
        const role = storage.getRole();

        if(role == constants.userRoles.reviewer){
            tenantId = storage.getTenant()?.firm?._id || '';
        }
        else if(role == constants.userRoles.firmManager || role == constants.userRoles.projectManager || role == constants.userRoles.projectOwner){
            /**
             * MP-5636: deliberately the ACTING firm, not the family root.
             *
             * `X-Tenant-Id` is the firm the caller is acting as, and the API
             * depends on that: work items - jobs, projects, positions,
             * documents, timesheets, talent pools, messages - are keyed to the
             * child that owns them ("identity up, work down"). Sending the
             * root here would silently re-attribute every one of them to the
             * parent; `endpoints/jobs.js` sets a job posting's owning firm
             * straight from this header.
             *
             * Where the SERVER needs the family root instead - matching a
             * reviewer's `tenants[].firm`, which is root-keyed - it derives it
             * itself via `middlewares/resolveTenantRoot` (`req.tenantRootId`).
             * That is the right place for it: scoping is not a decision to
             * delegate to a client.
             *
             * MP-5643: `getUserFirmId()` now RETURNS the acting firm - the
             * switcher's selected child for a root-attached FM, their own
             * firm otherwise - so selecting a child is the whole mechanism.
             * No new parameter and no per-screen change. For a standalone
             * firm, and for a root FM who has selected nothing, it is the
             * user's own firm exactly as before.
             */
            tenantId = userService.getUserFirmId() || '';
        }

        const clonedRequest = request.clone({
            setHeaders: {
                'X-Api-Token': `${token}`,
                'X-Tenant-Id':  `${tenantId}`
            }
        });
        return next(clonedRequest);
    }

    return next(request);
};